<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:90%;min-height: 600px;">
    <mat-card-header>
      </mat-card-header>    
    <mat-card-content>
        
        <ng-container *ngIf="isDev">
        <hr />
            Is Taxable: {{isCurrentInvoiceLineTaxable}}<br />
            Tax Rate: {{currentInvoiceTaxRate}}<br />
            Net Amount Min Limit: {{netAmountMinimumLimit}}<br />
            Net Amount Max Limit: {{netAmountMaximumLimit}}<br />
            Gross Amount Min Limit: {{grossAmountMinimumLimit}}<br />
            Gross Amount Max Limit: {{grossAmountMaximumLimit}}<br />
            Hide Invoice Lines: {{showZeroBalanceInvoiceLines}}<br />
        <hr/>
        </ng-container>

        @if(showWaitMessage){
            <app-processing-banner WaitMessage="Saving Invoice Adjustment..."></app-processing-banner>
        }
        
        <form 
        (ngSubmit)="onSubmitNewInvoiceAdjustment()" 
        novalidate
        [formGroup]="gbInvoiceLineForm" 
        
        style="margin-top:20px;">
        <div class="row">
            <div class="col-5">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label  class="form-text">Select Invoice Item</mat-label>
                    <mat-select formControlName="invoiceLineItem"   class="form-text" (selectionChange)="onInvoiceLineSelectionChange()">
                      <mat-option value=""    class="form-text">Select Invoice Item</mat-option>
                      <mat-option *ngFor="let billingLine of invoiceBillingLines" [value]="billingLine.primaryKey"     class="form-text">
                                {{billingLine.lineItemName}}  --   
                                {{billingLine.totalAmount + billingLine.adjustment | currency}}  --
                                {{billingLine.description}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                        <mat-checkbox
                        style="position:relative;top: -5px;"
                        (change)="onChangeShowBillingLines()"
                        [checked]="showZeroBalanceInvoiceLines">
                        Hide Zero Balance Billing Lines
                        </mat-checkbox>
            </div>
            <div class="col-1">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label>Date</mat-label>
                    <input matInput placeholder="Date"  formControlName="currentDate" autocomplete="chrome-off" readonly  class="form-text">
                  </mat-form-field>
            </div>
            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label  style="font-size:13px;">Net</mat-label>
                    <input matInput placeholder="Net" formControlName="netAmount" autocomplete="chrome-off"  maxlength="32"    class="form-text" (blur)="onNetAmountLostFocus()" [readonly]="netAmountReadOnly">
                    <mat-error *ngIf="gbInvoiceLineForm.get('netAmount')!.hasError('required')">The net amount is required</mat-error>
                    <mat-error *ngIf="gbInvoiceLineForm.get('netAmount')!.hasError('min')">Must be &gt; {{netAmountMinimumLimit}}</mat-error>
                    <mat-error *ngIf="gbInvoiceLineForm.get('netAmount')!.hasError('max')">Must be &lt; {{netAmountMaximumLimit}}</mat-error>
                  </mat-form-field>
            </div>
            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label   class="form-text">Gross</mat-label>
                    <input matInput placeholder="Gross" formControlName="grossAmount" autocomplete="chrome-off"  maxlength="32"   class="form-text" (blur)="onGrossAmountLostFocus()" [readonly]="grossAmountReadOnly">
                    <mat-error *ngIf="gbInvoiceLineForm.get('grossAmount')!.hasError('required')">The gross amount is required</mat-error>
                    <mat-error *ngIf="gbInvoiceLineForm.get('grossAmount')!.hasError('min')">Must be &gt;  {{grossAmountMinimumLimit}}</mat-error>
                    <mat-error *ngIf="gbInvoiceLineForm.get('grossAmount')!.hasError('max')">Must be &lt;  {{grossAmountMaximumLimit}}</mat-error>
                  </mat-form-field>
            </div>
            
            
            <div class="col-2">
                <mat-form-field appearance="fill" style="width:100%;color:gray">
                    <mat-label    class="form-text">Reason for Adjustment</mat-label>
                    <mat-select formControlName="adjustmentReason"   class="form-text">
                      <mat-option value=""    class="form-text">Select Reason for Adjustment</mat-option>
                      <mat-option *ngFor="let adjustmentReason of invoiceAdjustmentReasons" [value]="adjustmentReason.adjustmentReasonId"    class="form-text">
                        {{adjustmentReason.reason}} 
                      </mat-option>
                    </mat-select>
                    <mat-error>The Adjustment Reason is required</mat-error>
                  </mat-form-field>
            </div>
        </div>
        <div class="row" style="margin-top:15px;">
            <div class="col-12">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label class="form-text">Comment</mat-label>
                    <input matInput placeholder="Comment" formControlName="adjustmentComment" autocomplete="chrome-off" maxlength="512"  class="form-text" (blur)="onAdjustmentCommentLostFocus()">
                    <mat-error>The Comment is required</mat-error>
                  </mat-form-field>
            </div>
        </div>
        

            <div class="row">
                <div class="col-6">
                    
                    <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:5px;" [disabled]="!gbInvoiceLineForm.valid == true">Submit</button>
                    <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:15px;" (click)="resetInvoiceBillingLineData()">Clear</button>
                </div>
            </div>
        </form>


        <div style="margin-top:20px;"></div>
    
        <ng-container class="ml-4" *ngIf="completedAdjustmentsGB?.length">
            <strong style="font-size:14px;margin-left:20px;margin-top:30px;">Adjusted Invoice Lines</strong>
            <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
            <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;">
                <th style="font-size:12px;">
                    Date
                </th>
    
                <th style="font-size:12px;width:30%;">
                    Description
                </th>
            
             
    
                <th style="font-size:12px;">
                    Reason
                </th>
    
                <th style="font-size:12px;">
                    Comment
                </th>

                <th style="font-size:12px;">
                    User Name
                </th>
    
                <th style="font-size:12px;text-align: right;">
                    Net Amount
                </th>
    
                <th style="font-size:12px;text-align: right;">
                    Tax
                </th>
    
                <th style="font-size:12px;text-align: right;">
                    <div style="margin-right:10px;">
                        Gross Amount
                    </div>
                </th>
               
              
                
                <tr *ngFor="let adjustmentLine of completedAdjustmentsGB;let i = index">
                    <td style="font-size:12px;">
                       {{adjustmentLine.adjustmentDate | date:'shortDate'}}
                    </td>
    
                    <td style="font-size:12px;">
                        {{adjustmentLine.customerName}} -- {{adjustmentLine.description}}
                     </td>
    
                     <td style="font-size:12px;">
                        {{adjustmentLine.reason}}
                     </td>
    
                     <td style="font-size:12px;">
                        {{adjustmentLine.comments}}
                     </td>

                     <td style="font-size:12px;">
                        {{adjustmentLine.userName}}
                     </td>
                
                     <td style="font-size:12px;color:red;text-align: right;">
                        {{adjustmentLine.adjustmentAmount | currency}}
                    </td>
    
                    <td style="font-size:12px;color:red;text-align: right;">
                        {{adjustmentLine.taxAmount | currency}}
                    </td>
    
                    <td style="font-size:12px;color:red;text-align: right;margin-right:7px;">
                        <div style="margin-right:10px;">
                        {{adjustmentLine.grossAdjustmentValue | currency}}
                        </div>
                    </td>
                </tr>
            
            </table>   
            </div>
        </ng-container>
    </mat-card-content>
    <mat-card-actions style="margin-top:20px;">
        <hr />
    
      </mat-card-actions>
</mat-card>
